import { createService } from '@bonanza-social/toolkit/api';
import {
  CommunityJackpotEventsSchema,
  ClaimCommunityEventRewardsSchema,
} from './CommunityJackpotService.schemas';

export default createService(
  {
    getCommunityEvents: {
      method: 'GET',
      url: '/communityEvents',
      responseSchema: CommunityJackpotEventsSchema,
    },
    claimCommunityEventRewards: {
      method: 'POST',
      url: '/Rewards/redemptionsPerType',
      responseSchema: ClaimCommunityEventRewardsSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
